/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom } from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom';
import {
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomToJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomToJSONTyped,
} from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed
 */
export interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    room?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoom;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerOccupanciesInnerBed(value: object): value is IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed {
    return true;
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'room': json['room'] == null ? undefined : IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomFromJSON(json['room']),
    };
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedToJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedToJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedToJSONTyped(value?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'room': IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomToJSON(value['room']),
    };
}

